<smrts-page tabTitle="Relatório Financeiro">

  <div header class="header-outer">
    <h1 #overflow="smrtsOverflowDetector" smrtsOverflowDetector class="primary-color page-title"
    matTooltip="Relatório Financeiro" [matTooltipDisabled]="!overflow.truncado">Relatório Financeiro</h1>

    <form [formGroup]="form" class="filtros-container header inline-element">

      <!-- Tipo de busca -->
      <div class="filtro-campo">
        <app-generic-autocomplete [items]="opcoesTipoBusca" displayField="label" label="Tipo de busca"
          inputId="tipoBusca" formControlName="tipoBusca" (selectionChange)="onTipoBuscaChange()">
        </app-generic-autocomplete>
      </div>

      <!-- Campo dinâmico: Conta ou Tipo de Lançamento -->
      <div class="filtro-campo">
        <app-generic-autocomplete [items]="selecaoBuscaItens" displayField="nome" [label]="selecaoBuscaLabel"
          inputId="idSelecionado" formControlName="idSelecionado">
        </app-generic-autocomplete>
      </div>

      <!-- Datas -->
      <div class="filtro-datas">

        <div class="filtro-campo">
          <p-floatlabel variant="on">
            <p-datepicker inputId="dataInicio" [showIcon]="true" dateFormat="dd/mm/yy" formControlName="dataInicio" [fluid]="true" />
            <label for="dataInicio">Data início</label>
          </p-floatlabel>
        </div>

        <div class="filtro-campo">
          <p-floatlabel variant="on">
            <p-datepicker inputId="dataFim" [showIcon]="true" dateFormat="dd/mm/yy" formControlName="dataFim" [fluid]="true" />
            <label for="dataFim">Data fim</label>
          </p-floatlabel>
        </div>

      </div>

      <!-- Botão buscar -->
      <button class="white-text-button btn-buscar" mat-flat-button (click)="buscar()">
        Buscar
      </button>

    </form>

    <button class="white-text-button btn-busca-popover" mat-raised-button matTooltip="Filtros" (click)="popoverFiltros.toggle($event)">
      <mat-icon>search</mat-icon>
    </button>

    <p-popover #popoverFiltros appendTo="body">
      <div class="popover-filtros-content">

        <div class="filtro-campo">
          <app-generic-autocomplete [items]="opcoesTipoBusca" displayField="label" label="Tipo de busca"
            inputId="tipoBuscaPopover" [formControl]="$any(tipoBuscaControl)" (selectionChange)="onTipoBuscaChange()">
          </app-generic-autocomplete>
        </div>

        <div class="filtro-campo">
          <app-generic-autocomplete [items]="selecaoBuscaItens" displayField="nome" [label]="selecaoBuscaLabel"
            inputId="idSelecionadoPopover" [formControl]="$any(idSelecionadoControl)">
          </app-generic-autocomplete>
        </div>

        <div class="filtro-campo">
          <p-floatlabel variant="on">
            <p-datepicker inputId="dataInicioPopover" [showIcon]="true" dateFormat="dd/mm/yy" [formControl]="$any(dataInicioControl)" [fluid]="true" />
            <label for="dataInicioPopover">Data início</label>
          </p-floatlabel>
        </div>

        <div class="filtro-campo">
          <p-floatlabel variant="on">
            <p-datepicker inputId="dataFimPopover" [showIcon]="true" dateFormat="dd/mm/yy" [formControl]="$any(dataFimControl)" [fluid]="true" />
            <label for="dataFimPopover">Data fim</label>
          </p-floatlabel>
        </div>

        <button class="white-text-button" mat-flat-button (click)="buscar(); popoverFiltros.hide()">
          Buscar
        </button>

      </div>
    </p-popover>

    <mat-divider *hasPermission="permissaoEditarRelatorioCaixa" [vertical]="true" class="vertical-mat-divider"></mat-divider>

    <a *hasPermission="permissaoEditarRelatorioCaixa" routerLink="/configurar-relatorio-caixa"
      mat-flat-button matTooltip="Configurar Relatório Caixa" class="white-text-button btn-configurar">
      <mat-icon>settings</mat-icon>
    </a>
  </div>

  <div class="content">

    @if (temResultado) {
      <!-- Resumo financeiro -->
      <div class="resumo-container inline-element">
        <mat-card class="resumo-card">
          <p class="resumo-label">Total Receita</p>
          <p class="resumo-valor green-text">{{ resultado!.totalReceita | currency:'BRL' }}</p>
        </mat-card>
        <mat-card class="resumo-card">
          <p class="resumo-label">Total Despesa</p>
          <p class="resumo-valor red-text">{{ resultado!.totalDespesa | currency:'BRL' }}</p>
        </mat-card>
        <mat-card class="resumo-card">
          <p class="resumo-label">Saldo</p>
          <p class="resumo-valor" [ngClass]="{'green-text': resultado!.saldo >= 0, 'red-text': resultado!.saldo < 0}">
            {{ resultado!.saldo | currency:'BRL' }}
          </p>
        </mat-card>
      </div>
      <!-- Card com abas: Lançamentos e Visão Gráfica -->
      <mat-card class="lancamentos-card">
        <p-tabs [(value)]="abaAtiva">
          <p-tablist>
            <p-tab value="0">Lançamentos</p-tab>
            <p-tab value="1">Visão Gráfica</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              <app-relatorio-lancamentos
                [resultado]="resultado!"
                [tiposLancamento]="tiposLancamento"
                (refreshar)="buscar()">
              </app-relatorio-lancamentos>
            </p-tabpanel>
            <p-tabpanel value="1">
              <!-- @if garante que o canvas seja criado com dimensões corretas -->
              @if (abaAtiva === '1') {
                <app-relatorio-graficos
                  [resultado]="resultado!"
                  (duplocliquePizza)="buscarCategoriaChart($event)"
                  (duploCliqueBarra)="buscarBarraChart($event)">
                </app-relatorio-graficos>
              }
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </mat-card>
    }

  </div>

</smrts-page>
